// ** react imports
import clsx from 'clsx';

// ** styles imports
import './styles.css';

const Loading = ({ className = '', size }) => {
  // Define size classes
  const sizeClasses = {
    small: 'loader-small',
    medium: 'loader-medium',
    large: 'loader-large',
  };

  // Get the appropriate size class, defaulting to no additional class if size is not specified
  const sizeClass =
    size && sizeClasses[size] ? sizeClasses[size] : sizeClasses['medium'];

  return (
    <div
      className={clsx(
        'loader text-primary-600 dark:text-gray-300',
        sizeClass,
        className
      )}
    />
  );
};

export default Loading;
